module.exports = __webpack_public_path__ + "img/claass-logo-white-without-betta.06df0d4c.svg";